import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import ParentCategories from 'modules/budget/components/category/category-table/parent-categories';
import AddRootCategoryButton from 'modules/budget/components/category/category-table/add-root-category-button';

@withNamespaces()
@inject('store')
@observer
class CategoryTable extends Component {
    render() {
        const { t, store, hidden } = this.props;
        const categories = hidden ? store.categories.hidden : store.categories.categories;

        return (
            <table className="table table-condensed table-hover">
                <thead>
                <tr>
                    <th>
                        {t('BUDGET.CATEGORY.NAME')}
                        &nbsp;
                        {!hidden && <AddRootCategoryButton />}
                    </th>
                    <th>{t('COMMON.ACTIONS')}</th>
                </tr>
                </thead>
                <tbody>
                <ParentCategories categories={categories} hidden={hidden} />
                </tbody>
                {!hidden && (
                    <tfoot>
                    <tr>
                        <td colSpan={2}>
                            <AddRootCategoryButton />
                        </td>
                    </tr>
                    </tfoot>
                )}
            </table>
        )
    }
}

CategoryTable.propTypes = {
    hidden: PropTypes.bool,
};

export default CategoryTable;


// WEBPACK FOOTER //
// ./src/modules/budget/components/category/category-table/category-table.js